import { createContext } from "react";

const Toast_message = createContext({} as any);

export default Toast_message;
